import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { first, last, split } from 'lodash-es';

@Component({
  selector: 'shared-video-player',
  imports: [],
  templateUrl: './videoPlayer.html',
  styleUrl: './videoPlayer.scss',
})
export class VideoPlayer {
  videoId = input.required<string | null | undefined>();
  private sanitizer = inject(DomSanitizer);

  id = computed(() => last(split(this.videoId(), ':')));
  platform = computed(() => first(split(this.videoId(), ':')));

  src = computed(() => {
    if (this.platform() === 'vimeo') {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`https://player.vimeo.com/video/${this.id()}?`);
    } else if (this.platform() === 'youtube') {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${this.id()}?rel=0`);
    } else {
      return null;
    }
  });
}
